import { useEffect } from "react";
import { SITE_URL as SITE } from "@/lib/site";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Client-side per-route SEO. Google renders JS and reads these updates.
export function useSEO({ title, description, keywords, path = "/", image, jsonLd }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || `${SITE}/og-image.jpg`;
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", title || "Endasphere");
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:title", title || "Endasphere");
    upsertMeta("name", "twitter:description", description || "");
    upsertMeta("name", "twitter:image", img);

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "page-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
    window.scrollTo(0, 0);
    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
    };
  }, [title, description, keywords, path, image, jsonLd]);
}
